var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.title),expression:"title",modifiers:{"hover":true}}],staticClass:"dimension tw-border-none tw-cursor-pointer tw-py-0 tw-px-4",class:{
    'active': _vm.active
  },attrs:{"title":_vm.title},on:{"click":_vm.select}},[_c(_vm.icon,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }